export default "__VITE_ASSET__C5cPi8RK__"